import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { JsonEditorDoc } from '../json-editor-doc.model';

@Injectable({
  providedIn: 'root'
})
export class JsonEditorService {

  constructor(private http: HttpClient) {
  }

  public createJsonEditorDoc(name: string, data: any): Observable<JsonEditorDoc> {
    const url = 'https://jsoneditoronline.herokuapp.com/v1/docs';
    return this.http.put<JsonEditorDoc>(url, { name, data });
  }
}
